import React, { useCallback, useState } from 'react';
import { Maximize2Icon } from 'lucide-react';
import { BowIcon } from './BowIcon';
import { CtaButton } from './CtaButton';
import { Lightbox } from './Lightbox';
import { Reveal } from './Reveal';
import { gifts, images, includes } from '../data/content';
import { CHECKOUT_ANCHOR_ID } from '../utils/scroll';
type OfferProps = {
  checkoutUrl: string;
};
const MOCKUP_ALT = 'Todo lo que incluye ELEGIDA: terapias, sesiones en vivo, comunidad privada y masterclasses de regalo';
export function Offer({
  checkoutUrl
}: OfferProps) {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  return <section id="oferta" className="bg-gradient-to-b from-ink to-wine px-6 py-24" data-id="element-93" data-mp="yxy0q41bd5si">
      <Reveal data-id="element-94" data-mp="z00wl4p5dt55">
        <h2 className="text-center font-serif text-[40px] font-bold leading-tight text-white" data-id="element-95" data-mp="2fc698up91el5">¿Qué es ELEGIDA?</h2>
        <p className="mt-6 text-center text-[17px] leading-relaxed text-muted" data-id="element-96" data-mp="2admlqpv0buqo">
          Elegida es un programa de 30 terapias ya grabadas y 30 días de acompañamiento profesional por WhatsApp
          que te convierte en una <span className="font-semibold text-white" data-id="element-97" data-mp="ui8xu3ba0ejc">Estratega</span>.
        </p>

        <button type="button" onClick={() => setOpen(true)} aria-label="Ampliar imagen de todo lo que incluye ELEGIDA" className="group relative mt-10 block w-full overflow-hidden rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-98" data-mp="zhvd0iao04us">
          <img src={images.mockup} alt={MOCKUP_ALT} className="h-auto w-full rounded-xl" data-id="element-99" data-mp="bs10k1u9cib2" />
          <span className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-ink/80 px-3 py-1.5 text-[11px] font-semibold text-gold backdrop-blur" data-id="element-100" data-mp="ftvxyv92ibjk">
            <Maximize2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-101" data-mp="kmywlhspcb6m" />
            Toca para ampliar
          </span>
        </button>

        <div className="mt-8 rounded-xl border border-gold bg-panel p-6" data-id="element-102" data-mp="3o9pjjoi9ad7h">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-103" data-mp="vfqvhxndb4q3">Incluye</h3>
          <ul className="mt-5 space-y-4" data-id="element-104" data-mp="vde8h62r6466">
            {includes.map(item => <li key={item} className="flex gap-3 text-[15px] leading-relaxed text-white" data-id="element-105" data-mp="qejpo44scfm2">
                <span aria-hidden="true" className="font-bold text-gold" data-id="element-106" data-mp="154qv9j9p245c">
                  ✓
                </span>
                <span data-id="element-107" data-mp="108tifmxn3fxb">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-4 rounded-xl border border-gold bg-panel p-6" data-id="element-108" data-mp="cipq4bpwj2lm">
          <h3 className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-109" data-mp="7jcsqx1emd4s">
            <BowIcon className="h-5 w-5" data-id="element-110" data-mp="liw19qy4nqhm" />
            Regalos incluidos
          </h3>
          <ul className="mt-5 space-y-4" data-id="element-111" data-mp="heehhrrrpd6u">
            {gifts.map(gift => <li key={gift} className="flex gap-3 text-[15px] leading-relaxed text-white" data-id="element-112" data-mp="1wvop4qnsruse">
                <BowIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-113" data-mp="1svwbhzjjqyg6" />
                <span data-id="element-114" data-mp="20ex8e1zudtuk">{gift}</span>
              </li>)}
          </ul>
        </div>

        <div id={CHECKOUT_ANCHOR_ID} className="scroll-mt-8" data-id="element-115" data-mp="25dqo812lpwxw">
          <div className="mt-14 text-center" data-id="element-116" data-mp="25f1rlzs4x2oh">
            <p className="font-serif text-[64px] font-bold leading-none text-gold" data-id="element-117" data-mp="1qgpwvyobo3zy">$97 USD</p>
            <p className="mx-auto mt-4 max-w-[320px] text-[15px] leading-relaxed text-muted" data-id="element-118" data-mp="1vfatzp8a27k6">
              Menos de $3.30 al día por 30 días de acompañamiento profesional.
            </p>
          </div>

          <div className="mt-9" data-id="element-119" data-mp="2o4rkghcc7edr">
            <CtaButton label="Quiero mi lugar en Elegida" href={checkoutUrl} data-id="element-120" data-mp="2o2wzx44z9oa7" />
          </div>
        </div>
      </Reveal>
      <Lightbox open={open} src={images.mockup} alt={MOCKUP_ALT} onClose={close} data-id="element-121" data-mp="29f26flj5bfw2" />
    </section>;
}